(function () {
    "use strict";

    var module = angular.module("app");

    module.directive("login", [
        function () {
            return {
                restrict: "E",
                scope: {},
                templateUrl: "/app/features/header/login/login.tpl.html",
                controller: "loginCtrl"
            };
        }
    ]);

    module.controller("loginCtrl", [
        "$scope", "authService", "$state", "currentUserService", "authenticationTokenService",
        function ($scope, authService, $state, currentUserService, authenticationTokenService) {
            $scope.username = "";
            $scope.password = "";

            $scope.login = function login() {
                var loginSuccess = function () {
                    if (currentUserService.isInRole("Admin")) {
                        $state.go("admin");
                    } else {
                         $state.go("myCellar");
                    }
                };

                var loginError = function (reason) {
                    toastr.error("Login failed - " + reason);
                };

                authService.login($scope.username, $scope.password)
                    .then(loginSuccess, loginError);
            };

            $scope.canLogin = function canLogin() {
                return $scope.username && $scope.password;
            };
        }
    ]);
}());